<template>
    <v-card class="rounded-lg">
        <v-card-title>Coaching</v-card-title>
        <v-divider></v-divider>

        <v-container>
            <v-card>
                <v-card-title>Rooms You Coach</v-card-title>
                <v-card-subtitle>Meeting rooms that you have access to as a Coach or QA role.</v-card-subtitle>
                <v-divider></v-divider>
                <v-card-text>
                    <v-simple-table v-if="true || coaching.length > 0" :key="coaching_table_key">
                        <template v-slot:default>
                            <thead>
                                <tr>
                                    <th>Room Name/Owner</th>
                                    <th></th>
                                    <th>Coach</th>
                                    <th>QA</th>
                                    <th>Join</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="room in coaching" :key="room.ID">
                                    <td class="py-2">
                                        <!-- <v-icon v-if="roomIsActive(room)" color="green">mdi-circle-medium</v-icon> -->
                                        {{room.post_title}}
                                        <div><small class="text--disabled">{{room.owner.data.display_name}} {{room.owner.data.user_email}}</small></div>
                                    </td>
                                    <td>
                                        <div v-if="roomIsActive(room)">
                                            <v-icon v-if="isCoachHandRaised(room)" color="yellow" class="mr-1">mdi-hand-front-right</v-icon>
                                            <v-chip v-for="participant in presence[room.ID]" :key="participant.user_id" small class="ma-1"
                                                :color="participant.role == 'host' 
                                                    ? 'success' 
                                                    : participant.role == 'coach' 
                                                        ? 'orange' 
                                                        : ''"
                                            >
                                                {{participant.user_name}}
                                            </v-chip>
                                        </div>
                                    </td>
                                    <td class="py-2">
                                        <v-icon v-if="room.can_coach" color="success">mdi-check-circle</v-icon>
                                    </td>
                                    <td>
                                        <v-icon v-if="room.can_qa" color="success">mdi-check-circle</v-icon>
                                    </td>
                                    <td>
                                        <v-btn icon @click="showJoinDialog(room)"><v-icon>mdi-open-in-new</v-icon></v-btn>
                                    </td>
                                </tr>
                            </tbody>
                        </template>
                    </v-simple-table>
                    <div v-else>No coaching accounts yet.</div>
                    <v-progress-linear indeterminate v-if="loading_coaches"></v-progress-linear>
                </v-card-text>
            </v-card>
        </v-container>

        <v-container v-if="user.userdata.roles && user.userdata.roles.length > 0">
            <v-card>
                <v-card-title>Your Coaches</v-card-title>
                <v-card-subtitle>People that have access to your meeting rooms as a Coach or QA role.</v-card-subtitle>
                <v-divider></v-divider>
                <v-card-text>
                    <v-simple-table v-if="coaches.length > 0">
                        <thead>
                            <tr>
                                <th>User</th>
                                <th>Rooms</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="coach in coaches" :key="coach.ID">
                                <td class="py-2">
                                    {{coach.data.display_name}}<br />
                                    <span color="secondary">{{coach.data.user_email}}</span>
                                </td>
                                <td class="py-2">
                                    <div v-for="room in displayRoomsAccess(coach.data.room_access)" :key="`${coach.ID}-${room.room_name}-${Math.random()}`">
                                        {{room.room_name}}:
                                        <span v-for="role in room.roles.sort()" :key="`${coach.ID}-${Math.random()}-${role}`" class="ml-2">{{role}}</span>
                                    </div>
                                </td>
                                <td>
                                    <v-btn icon @click="editCoach(coach)"><v-icon>mdi-pencil</v-icon></v-btn>
                                </td>
                            </tr>
                        </tbody>
                    </v-simple-table>
                    <v-progress-linear indeterminate v-if="loading_coaches"></v-progress-linear>
                </v-card-text>
                <v-card-actions class="pb-4">
                    <v-spacer></v-spacer>
                    <v-btn class="mt-8" @click="show_send_invitation = true" color="primary">Invite a Coach</v-btn>
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-container>

        <v-dialog width="800" max-width="100%" v-model="show_send_invitation" overlay-opacity="0.9" scrollable>
            <v-card outlined class="rounded-lg">
                <v-card-title>
                    Send Invitation
                </v-card-title>
                <v-card-text class="pa-6">
                    <p>You can invite someone to be able to access your meetings as a Coach or QA role. You can edit or revoke permissions at any time.</p>

                    <template v-if="rooms.length == 0">
                        <v-alert type="info">You will need to create a meeting room before you can invite a coach.</v-alert>
                    </template>
                    <template v-else>
                        <div class="font-weight-bold mt-8 mb-4">Send Invitation To:</div>
                        <v-row grow>
                            <v-col>
                                <v-text-field outlined hide-details label="First Name" v-model="first_name"></v-text-field>
                            </v-col>
                            <v-col>
                                <v-text-field outlined hide-details label="Last Name" v-model="last_name"></v-text-field>
                            </v-col>
                            <v-col>
                                <v-text-field outlined hide-details label="Email Address" v-model="email" type="email"></v-text-field>
                            </v-col>
                        </v-row>
                        <div class="font-weight-bold mt-8">Meeting Room Permissions</div>
                        <v-simple-table>
                            <template v-slot:default>
                                <thead>
                                    <tr>
                                        <th class="text-left">
                                            Room Name
                                        </th>
                                        <th class="text-left">
                                            Coach 
                                            <v-tooltip top max-width="300">
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-icon v-bind="attrs" v-on="on" color="grey" small>
                                                        mdi-information-outline
                                                    </v-icon>
                                                </template>
                                                <span>Coaches can join your meeting but can only be seen and heard by other coaches and hosts. Coaches are not seen or heard by guests in the meeting. Once permission is granted, they can enter any meeting at anytime in the specified room.</span>
                                            </v-tooltip>
                                        </th>
                                        <th class="text-left">
                                            QA (Quality Assurance)
                                            <v-tooltip top max-width="300">
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-icon v-bind="attrs" v-on="on" color="grey" small>
                                                        mdi-information-outline
                                                    </v-icon>
                                                </template>
                                                <span>QAs can quietly log into your meetings without being seen by you or your guests - good for supervisors or those in training. Once permission is granted, they can enter any meeting at anytime in the specified room.</span>
                                            </v-tooltip>
                                        </th>
                                        <th class="text-left">
                                            Reporting
                                            <v-tooltip top max-width="300">
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-icon v-bind="attrs" v-on="on" color="grey" small>
                                                        mdi-information-outline
                                                    </v-icon>
                                                </template>
                                                <span>You can grant access to data about your meeting room activity to others for analysis.</span>
                                            </v-tooltip>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="room in rooms" :key="room.ID">
                                        <td>
                                            {{ room.post_title }}<br />
                                        </td>
                                        <td>
                                            <v-switch v-model="room.can_coach"></v-switch>
                                        </td>
                                        <td>
                                            <v-switch v-model="room.can_qa"></v-switch>
                                        </td>
                                        <td>
                                            <v-switch v-model="room.can_access_reports"></v-switch>
                                        </td>
                                    </tr>
                                </tbody>
                            </template>
                        </v-simple-table>
                    </template>
                </v-card-text>
                <v-card-actions class="pb-4 pr-6">
                    <v-spacer></v-spacer>

                    <v-btn v-if="rooms.length == 0" @click="show_send_invitation = false">Close</v-btn>
                    <v-btn v-else color="primary" @click="sendInvitation" :loading="sending">Send</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!-- EDIT COACH ROLES -->
        <v-dialog width="800" max-width="100%" v-if="show_edit_coach" v-model="show_edit_coach" overlay-opacity="0.9" scrollable>
            <v-card outlined class="rounded-lg">
                <v-card-title>
                    Edit User Access for {{edit_coach.data.display_name}}
                </v-card-title>
                <v-card-text class="pa-6">
                    
                    <div class="font-weight-bold mt-8">Meeting Room Permissions</div>
                    <v-simple-table>
                        <template v-slot:default>
                            <thead>
                                <tr>
                                    <th class="text-left">
                                        Room Name
                                    </th>
                                    <th class="text-left">
                                        Coach 
                                        <v-tooltip top max-width="300">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-icon v-bind="attrs" v-on="on" color="grey" small>
                                                    mdi-information-outline
                                                </v-icon>
                                            </template>
                                            <span>Coaches can join your meeting but can only be seen and heard by other coaches and hosts. Coaches are not seen or heard by guests in the meeting. Once permission is granted, they can enter any meeting at anytime in the specified room.</span>
                                        </v-tooltip>
                                    </th>
                                    <th class="text-left">
                                        QA (Quality Assurance)
                                        <v-tooltip top max-width="300">
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-icon v-bind="attrs" v-on="on" color="grey" small>
                                                    mdi-information-outline
                                                </v-icon>
                                            </template>
                                            <span>QAs can quietly log into your meetings without being seen by you or your guests - good for supervisors or those in training. Once permission is granted, they can enter any meeting at anytime in the specified room.</span>
                                        </v-tooltip>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="room in rooms" :key="room.ID">
                                    <td>
                                        {{ room.post_title }}<br />
                                    </td>
                                    <td>
                                        <v-switch v-model="room.can_coach"></v-switch>
                                    </td>
                                    <td>
                                        <v-switch v-model="room.can_qa"></v-switch>
                                    </td>
                                </tr>
                            </tbody>
                        </template>
                    </v-simple-table>
                </v-card-text>
                <v-card-actions class="pb-4 pr-6">
                    <v-spacer></v-spacer>
                    <v-btn color="primary" @click="saveCoach" :loading="saving_coach">Save</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog max-width="500" v-model="show_join_dialog" overlay-opacity="0.9">
            <v-card>
                <v-card-title>Join {{join_room.post_title}}</v-card-title>
                <v-card-text>
                    <v-text-field outlined label="Meeting URL" :value="getJoinUrl(join_room)">
                        <template v-slot:append>
                            <v-btn icon @click="copyURL(getJoinUrl(join_room))">
                                <v-icon>mdi-content-copy</v-icon>
                            </v-btn>
                            <v-btn icon :href="getJoinUrl(join_room)" target="_blank">
                                <v-icon>mdi-open-in-new</v-icon>
                            </v-btn>
                        </template>
                    </v-text-field>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn @click="show_join_dialog = false">Close</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-card>
</template>

<script>
// import { useAppStore } from '../../stores/app'
import { useUserStore } from '../../stores/user'
import { supabase } from '../../lib/supabaseClient'

export default {
    name: 'Roles',
    created: function() {
        // this.app = useAppStore()
        this.user = useUserStore()
    },
    data: function() {
        return {
            app: null,
            user: null,
            show_send_invitation: false,
            first_name: "",
            last_name: "",
            email: "",
            can_coach: true,
            can_qa: false,
            sending: false,
            rooms: [],
            loading: true,
            loading_coaches: true,
            coaches: [],
            coaching: [],
            show_edit_coach: false,
            edit_coach: {},
            saving_coach: false,
            show_join_dialog: false,
            join_room: {},
            presence_channel: null,
            presence: {},
            coaching_table_key: Math.random(),
            hands_raised: []
        }
    },
    mounted: function() {
        this.loadRooms()
        // this.createPresenceChannel()
    },
    methods: {
        createPresenceChannel() {
            this.presence_channel = supabase.channel('presenceChannel', {
                config: {
                    presence: {
                        key: `userId-${this.user.userdata.ID}`,
                    },
                },
            })
            this.presence_channel
                .on('presence', { event: 'sync' }, () => {
                    this.$set(this, 'presence', this.presence_channel.presenceState())
                    this.coaching_table_key = Math.random()
                    // console.log('presence', this.presence)
                    this.updateHandsRaised()
                })
                .subscribe(async (status) => {
                if (status === 'SUBSCRIBED') {
                    const presenceTrackStatus = await this.presence_channel.track({
                        user_id: this.user.userdata.ID,
                        user_name: this.user.userdata.data.display_name,
                        online_at: new Date().toISOString(),
                    })
                    // console.log("presenceTrackStatus", presenceTrackStatus)
                }
            })
        },
        isCoachHandRaised(room) {
            let is_raised = false
            this.presence[room.ID].forEach(item => {
                if(item.coach_hand_raised) 
                    is_raised = true
            })

            // if(is_raised && !this.hands_raised.includes(room.ID)) {
            //     this.hands_raised.push(room.ID)
            // } else if (!is_raised) {
            //     let hands_raised = this.hands_raised.filter(item => {
            //         console.log("item", item, room.ID)
            //         item != room.ID
            //     })
            //     this.hands_raised = hands_raised
            // }
            return is_raised
        },
        updateHandsRaised() {
            let coaching_room_ids = Object.keys(this.coaching)
            let presence_room_ids = Object.keys(this.presence)
            let intersection = coaching_room_ids.filter(x => presence_room_ids.includes(x))
            intersection.forEach(room_id => {

            })

        },
        roomIsActive(room) {
            return this.presence[room.ID] ? true : false
        },
        async copyURL(text) {
            try {
                await navigator.clipboard.writeText(text);
                this.user.app.showSuccess("Copied to clipboard!")
            } catch($e) {
                console.error($e)
            }
        },
        getJoinUrl: function(room) {
            return `${room.site_url}/${room.post_name}`
        },
        showJoinDialog: function(room) {
            this.join_room = room
            this.show_join_dialog = true
        },
        sendInvitation: function() {
            // console.log(this.email, this.can_coach, this.can_qa)
            this.sending = true

            let data = {
                first_name: this.first_name,
                last_name: this.last_name,
                email: this.email,
                rooms: []
            }

            this.rooms.forEach(room => {
                data.rooms.push({
                    ID: room.ID, 
                    can_coach: room.can_coach ?? false,
                    can_qa: room.can_qa ?? false,
                    can_access_reports: room.can_access_reports ?? false,
                })
            })


            this.user.app.post('meeting/send-invitation', data)
            .then(response => {
                this.sending = false
                this.user.app.showSuccess('Invitation Sent!')
                this.show_send_invitation = false
                this.first_name = ''
                this.last_name = ''
                this.email = ''
            })
            .catch(error => {
                this.sending = false
                this.user.app.showError('Oops! Something went wrong.')
            })
        },
        saveCoach: function() {
            this.saving_coach = true
            let data = {
                user_id: this.edit_coach.ID,
                rooms: []
            }

            this.rooms.forEach(room => {
                data.rooms.push({
                    ID: room.ID, 
                    can_coach: room.can_coach ?? false,
                    can_qa: room.can_qa ?? false
                })
            })


            this.user.app.post('meeting/update-coach', data)
            .then(response => {
                this.saving_coach = false
                this.user.app.showSuccess('Access updated!')
                this.show_edit_coach = false
            })
            .catch(error => {
                this.saving_coach = false
                this.user.app.showError('Oops! Something went wrong.')
            })
        },
        loadRooms: function() {
            this.loading = true
            // this.user.app.get('meeting/rooms?all=1')
            this.user.app.get('meeting/rooms')
                .then(response => {
                    this.rooms = response.data.rooms
                    this.loadCoaches()
                    this.loading = false
                })
                .catch(error => {
                    console.error(error)
                    this.loading = false
                    this.user.app.showError('Oops! Something went wrong.')
                })
        },
        loadCoaches: function() {
            this.loading_coaches = true
            this.user.app.get('meeting/coaches')
                .then(response => {
                    this.loading_coaches = false
                    this.coaches = response.data.coaches
                    this.coaching = response.data.coaching
                })
                .catch(error => {
                    console.error(error)
                    this.loading_coaches = false
                    this.user.app.showError('Oops! Something went wrong.')
                })
        },
        displayRoomsAccess: function(room_access) {
            let rooms = []
            room_access.forEach(room => {
                let parts = room.split('_')
                let room_id = parts[1]
                let role = parts[2].toUpperCase()
                let index = this.rooms.findIndex(item => item.ID == room_id)
                let room_name = this.rooms[index]?.post_title
                // rooms += `${this.rooms[index].post_title} ${role}<br />`
                if(!rooms[room_name])
                    rooms[room_name] = []
                rooms[room_name].push(role)
                
            })
            let results = Object.keys(rooms).map(item => {
                return {"room_name": item, roles: rooms[item]}
            })
            // console.log(rooms, Object.keys(rooms))
            // console.log("displayRoomsAccess", results)
            return results
        },
        editCoach: function(coach) {
            this.edit_coach = coach

            // this.rooms.forEach(room => {
                this.edit_coach.data.room_access.forEach(room_access => {
                    let parts = room_access.split('_')
                    let room_id = parts[1]
                    let role = parts[2]
                    let index = this.rooms.findIndex(item => item.ID == room_id)
                    // console.log('room_id', room_id, 'index', index, this.rooms[index])
                    if(role == 'coach')
                        this.rooms[index].can_coach = true
                    else
                        this.rooms[index].can_qa = true
                })
            // })

            this.show_edit_coach = true
            // console.log(coach)
        }
    },
    watch: {
        hands_raised: function(newV, oldV) {
            // console.log("watching hands", newV, oldV)
            if(newV.length > oldV.length) {
                // console.log("play notification")
                this.app.playNotification('PEER_JOINED')
            }
        }
    }
}
</script>
